import * as React from "react";
import { TrackerProvider as RCTrackerProvider } from "react-tracker";

import configuredTracker from "./configuredTracker";
import { useCreateTrackingData } from "../../helpers/satiBack";
import { useTrackingPersistor } from "../../hooks/useTrackingPersistor";

function TrackerProvider({ children }) {
  const { mutateAsync: createTrackingData } = useCreateTrackingData();
  
  const { 
    addEvents, 
    persist, 
    hasPending 
  } = useTrackingPersistor(createTrackingData);

  /** Listens to all tracking events and adds them to the persistor */
  React.useEffect(() => {
    const handleEvent = (event) => {
      addEvents([event]);
    };

    configuredTracker.on("*", handleEvent);
    
    return () => {
      // Assuming react-tracker has an 'off' method or similar for cleanup
      // if not, we might need a different approach to avoid leaks
      // configuredTracker.off("*", handleEvent);
    };
  }, [addEvents]);

  /**
   * Debounced persist function.
   * Triggers the save tracking data function after 2.5 seconds of interaction.
   */
  React.useEffect(() => {
    if (!hasPending) return;

    const debouncedOnSave = setTimeout(() => {
      persist();
    }, 2500);

    return () => clearTimeout(debouncedOnSave);
  }, [hasPending, persist]);

  return (
    <RCTrackerProvider tracker={configuredTracker}>
      {children}
    </RCTrackerProvider>
  );
}

export default TrackerProvider;
